module.exports = __webpack_public_path__ + "static/media/KatinaMalke.7fa382a2.png";